import React from 'react';
import { observer, inject } from 'mobx-react';
import { makeObservable } from 'mobx';
import autobind from 'autobind';

import { Ehr } from '@patient/store/ehr/Ehr';

import { formatPhoneNumber } from '@utils/formatPhoneNumber';
import { getAgeDifference } from '@utils/getAgeDifference';

import { withRouter, WithRouterProps } from '@components/HOC/withRouterProps';

import { PatientInfo } from './PatientInfo';
import { AppState } from '@store/App/App';

interface PatinetInfoContainerProps {
    togglePatientInfoShowing(): void;
}

interface StoreProps {
    ehr: Ehr;
    app: AppState;
}

const injectableStores: (keyof StoreProps)[] = [Ehr.Name, AppState.Name];

@(withRouter as any)
@observer
class Component extends React.Component<PatinetInfoContainerProps & WithRouterProps & StoreProps> {
    constructor(props: PatinetInfoContainerProps & WithRouterProps & StoreProps) {
        super(props);
        makeObservable(this);
    }

    public render(): React.ReactNode {
        const { ehr, togglePatientInfoShowing } = this.props;

        return React.createElement(PatientInfo, {
            togglePatientInfoShowing,
            patientName: ehr.fullName,
            recordNumber: ehr.recordId,
            birthDate: ehr.birthDate,
            age: this.age,
            phone: this.phone,
            email: ehr.email,
            assistantsChats: ehr.assistantsChats,
            onPatientNameClick: this.onPatientNameClick,
        });
    }

    private get age(): string {
        const { ehr } = this.props;
        return getAgeDifference(ehr.rawBirthDate);
    }

    private get phone(): string {
        const { ehr } = this.props;
        return formatPhoneNumber(ehr.phone) ?? '';
    }

    @autobind
    private onPatientNameClick(): void {
        const { ehr, navigate } = this.props;
        navigate(`/patient/${ehr.recordId}`);
    }
}

export const PatientInfoContainer = inject<PatinetInfoContainerProps, StoreProps>(...injectableStores)(Component);
